import React from "react";
import userService from "../services/NavaService";

export default function SignInForm({ onSuccess, notice, onSwitch }) {
  const [state, setState] = React.useState({ email: "", password: "" });
  const [loading, setLoading] = React.useState(false);
  const [error, setError] = React.useState("");

  const handleChange = (evt) =>
    setState({ ...state, [evt.target.name]: evt.target.value });

  const handleOnSubmit = async (evt) => {
    evt.preventDefault();
    setError("");
    setLoading(true);

    try {
      const user = await userService.login(state.email, state.password);

      // Save basic token/user (so authHeader can read it if needed)
      localStorage.setItem("user", JSON.stringify(user));
      localStorage.setItem("token", user.accessToken);

      // Fetch roles (protected call)
      let isAdminStored = false;
      try {
        const rolesResp = await userService.getUserRoleByUsrId(user.id);
        const rolesList = rolesResp.data;

        if (Array.isArray(rolesList) && rolesList.length > 0) {
          const firstRole = rolesList[0];
          if (firstRole.adminYn !== undefined) {
            localStorage.setItem("isAdmin", firstRole.adminYn);
            isAdminStored = true;
          }
        }
      } catch (rolesErr) {
        console.error("Error loading user roles", rolesErr);
      }

      // Fallback to checking JWT roles if roles endpoint didn't give admin flag
      if (!isAdminStored) {
        const isAdminByRole =
          Array.isArray(user.roles) && user.roles.includes("ROLE_ADMIN");
        localStorage.setItem("isAdmin", isAdminByRole ? "Y" : "N");
      }

      // call parent handler (LoginModal passed onSuccess)
      if (typeof onSuccess === "function") {
        onSuccess(user); // parent will close modal and show success alert
      }
    } catch (err) {
      console.error("Login failed", err);
      if (err.response && err.response.status === 401) {
        setError("Invalid credentials");
      } else {
        setError("Login failed — try again");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="nava-auth-form-container nava-auth-signin">
      <div className="form-content">
        <form onSubmit={handleOnSubmit} autoComplete="off">
          <h1>Sign in</h1>

          {notice && <div style={{ marginBottom: 12 }}>{notice}</div>}
          {error && <div style={{ color: "red", marginBottom: 8 }}>{error}</div>}

          <input
            type="email"
            placeholder="Email"
            name="email"
            value={state.email}
            onChange={handleChange}
            required
          />
          <input
            type="password"
            name="password"
            placeholder="Password"
            value={state.password}
            onChange={handleChange}
            required
          />

          <a href="#" style={{ marginBottom: 12, display: "inline-block" }}>
            Forgot your password?
          </a>

          <button type="submit" className="nava-auth-submit" disabled={loading}>
            {loading ? "Signing in..." : "Sign In"}
          </button>

          <div className="mobile-switch">
            <button
              type="button"
              className="nava-auth-switch"
              onClick={() => onSwitch("signUp")}
            >
               New user? Sign Up
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

